import { useSessionStorage } from '@vueuse/core'
import { reactive, computed } from 'vue'

function isUndefined(value: any) {
  return value === undefined
}

// === 替代 defineStore 的全局状态 ===
const state = reactive({
  baseUrl: [],
  language: 'zh_CN',
  currentCountryObj: {
    countryId: 0,
    countryNameAbbr: 'ALL',
    countryNameForShow: 'All',
    defaultSort: 0,
    icon: '',
  },
  loadingCount: 0,
})

// === 持久化到 sessionStorage ===
const storage = useSessionStorage('influenbaseWebsite-systemConfig', state)

// === 模拟 actions ===
function setData(params: {
  baseUrl?: never[]
  language?: string
  currentCountryObj?: {
    countryId: number
    countryNameAbbr: string
    countryNameForShow: string
    defaultSort: number
    icon: string
  }
}) {
  const { baseUrl, language, currentCountryObj } = params
  storage.value.baseUrl = isUndefined(baseUrl) ? storage.value.baseUrl : baseUrl
  storage.value.language = isUndefined(language) ? storage.value.language : language
  storage.value.currentCountryObj = isUndefined(currentCountryObj)
    ? storage.value.currentCountryObj
    : currentCountryObj
}

// === 导出类似 Pinia 的接口 ===
export function useSystemConfigStore() {
  return {
    ...storage.value,
    state: storage,
    setData,
  }
}
